<div class="At-Container At-ContainerStoryPage">
    <div class="overlay"></div>
    <div class="At-StoryLeft">
        <a routerLink="/dashboard" class="At-BackBtnPage"><i class="icon-back-arrow"></i></a>
        <a routerLink="/dashboard" class="At-BackBtnCancel"><i class="icon-cancel"></i></a>
        <!-- <div class="At-StoryPage At-StoryPageW100"> -->
        <div class="At-StoryPage">
            <div class="At-StoryHeader">
                <div class="At-StoryProfileImg">
                    <figure>
                        <img src="assets/images/profile/profile-small.png" class="img-fluid " alt="">
                    </figure>
                </div>
                <div class="At-StoryTitle d-flex ">
                    <div class="At-StoryLeft">
                        <h5>Anatoli</h5>
                        <h6>2m ago</h6>
                    </div>
                    <div class="At-StoryRight d-flex">
                        <div class="At-LiveLabel">
                            <h6>LIVE</h6>
                        </div>
                        <div class="At-ViewLabel">
                            <h6><i class="icon-eye"></i>58</h6>
                        </div>
                    </div>
                </div>
            </div>
            <div class="At-StorySlider ">
                <figure>
                    <div class="At-OverlayImg"></div>
                    <img src="assets/images/story-video.jpg" class="img-fluid" alt="">
                </figure>
            </div>
        </div>
        <div class="At-BottomLive d-flex justify-content-between">
            <a href="javascript:void(0);" class="At-IconSpeaker">
                <i class="icon-sound-on"> </i>
                <i class="icon-sound-off d-none"> </i>
            </a>
            <h5>25:23</h5>
            <a href="javascript:void(0);" class="At-IconFullscreen">
                <i class="icon-full-screen"> </i>
            </a>
        </div>
    </div>
    <div class="At-StoryRight">
        <div class="At-AppCommentPost">
            <div class="At-Sidebar At-SidebarComment At-CustomScroll">
                <div class="At-SidebarShareTop">
                    <div class="At-SidebarShareTopInner">
                        <ul class="d-flex align-items-center">
                            <li class="At-LikeLi">
                                <h6><i class="icon-like"></i> 2211</h6>
                            </li>
                            <li>
                                <h6><i class="icon-comment"></i> 24</h6>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- At-SidebarShareTop ends  -->
                <div class="At-SidebarShareMiddle">
                    <div class="At-SidebarShareMiddleInner">

                        <div class="At-SidebarShareBtns">
                            <div class="At-InfoBox">
                                <div class="At-InfoImg">
                                    <figure class="At-FigureW55">
                                        <img src="assets/images/profile/profile-small4.png" class="img-fluid " alt="">
                                    </figure>
                                </div>
                                <div class="At-InfoTitle d-flex">
                                    <div class="At-TitleLeft">
                                        <h5>Nathaniel.DS: <span class="At-TextDarkGrey2">Bring me a hoodie from there
                                                will ya</span></h5>
                                        <ul class="At-LikesUl">
                                            <li>2m ago</li>
                                            <li>22 Likes</li>
                                            <li>REPLY</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <!-- At-InfoBox ends  -->

                            <div class="At-InfoBox">
                                <div class="At-InfoImg">
                                    <figure class="At-FigureW55">
                                        <img src="assets/images/profile/profile-small3.png" class="img-fluid " alt="">
                                    </figure>
                                </div>
                                <div class="At-InfoTitle d-flex">
                                    <div class="At-TitleLeft">
                                        <h5>Softpetal:): <span class="At-TextDarkGrey2">Enjooyy Sweetiee</span> <i
                                                class="icon-like At-TextRed"></i> </h5>
                                        <ul class="At-LikesUl">
                                            <li>2m ago</li>
                                            <li>22 Likes</li>
                                            <li>REPLY</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <!-- At-InfoBox ends  -->

                            <div class="At-InfoBox">
                                <div class="At-InfoImg">
                                    <figure class="At-FigureW55">
                                        <img src="assets/images/profile/profile-small4.png" class="img-fluid " alt="">
                                    </figure>
                                </div>
                                <div class="At-InfoTitle d-flex">
                                    <div class="At-TitleLeft">
                                        <h5>Nathaniel.DS: <span class="At-TextDarkGrey2">Bring me a hoodie from there
                                                will ya</span></h5>
                                        <ul class="At-LikesUl">
                                            <li>2m ago</li>
                                            <li>22 Likes</li>
                                            <li>REPLY</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <!-- At-InfoBox ends  -->

                            <div class="At-InfoBox">
                                <div class="At-InfoImg">
                                    <figure class="At-FigureW55">
                                        <img src="assets/images/profile/profile-small3.png" class="img-fluid " alt="">
                                    </figure>
                                </div>
                                <div class="At-InfoTitle d-flex">
                                    <div class="At-TitleLeft">
                                        <h5>Softpetal:): <span class="At-TextDarkGrey2">Enjooyy Sweetiee</span> <i
                                                class="icon-like At-TextRed"></i> </h5>
                                        <ul class="At-LikesUl">
                                            <li>2m ago</li>
                                            <li>22 Likes</li>
                                            <li>REPLY</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <!-- At-InfoBox ends  -->

                            <div class="At-InfoBox">
                                <div class="At-InfoImg">
                                    <figure class="At-FigureW55">
                                        <img src="assets/images/profile/profile-small3.png" class="img-fluid " alt="">
                                    </figure>
                                </div>
                                <div class="At-InfoTitle d-flex">
                                    <div class="At-TitleLeft">
                                        <h5>Softpetal:): <span class="At-TextDarkGrey2">Enjooyy Sweetiee</span> <i
                                                class="icon-like At-TextRed"></i> </h5>
                                        <ul class="At-LikesUl">
                                            <li>2m ago</li>
                                            <li>22 Likes</li>
                                            <li>REPLY</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <!-- At-InfoBox ends  -->

                            <div class="At-InfoBox">
                                <div class="At-InfoImg">
                                    <figure class="At-FigureW55">
                                        <img src="assets/images/profile/profile-small3.png" class="img-fluid " alt="">
                                    </figure>
                                </div>
                                <div class="At-InfoTitle d-flex">
                                    <div class="At-TitleLeft">
                                        <h5>Softpetal:): <span class="At-TextDarkGrey2">Enjooyy Sweetiee</span> <i
                                                class="icon-like At-TextRed"></i> </h5>
                                        <ul class="At-LikesUl">
                                            <li>2m ago</li>
                                            <li>22 Likes</li>
                                            <li>REPLY</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <!-- At-InfoBox ends  -->

                            <div class="At-InfoBox">
                                <div class="At-InfoImg">
                                    <figure class="At-FigureW55">
                                        <img src="assets/images/profile/profile-small3.png" class="img-fluid " alt="">
                                    </figure>
                                </div>
                                <div class="At-InfoTitle d-flex">
                                    <div class="At-TitleLeft">
                                        <h5>Softpetal:): <span class="At-TextDarkGrey2">Enjooyy Sweetiee</span> <i
                                                class="icon-like At-TextRed"></i> </h5>
                                        <ul class="At-LikesUl">
                                            <li>2m ago</li>
                                            <li>22 Likes</li>
                                            <li>REPLY</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <!-- At-InfoBox ends  -->

                            <div class="At-InfoBox">
                                <div class="At-InfoImg">
                                    <figure class="At-FigureW55">
                                        <img src="assets/images/profile/profile-small3.png" class="img-fluid " alt="">
                                    </figure>
                                </div>
                                <div class="At-InfoTitle d-flex">
                                    <div class="At-TitleLeft">
                                        <h5>Softpetal:): <span class="At-TextDarkGrey2">Enjooyy Sweetiee</span> <i
                                                class="icon-like At-TextRed"></i> </h5>
                                        <ul class="At-LikesUl">
                                            <li>2m ago</li>
                                            <li>22 Likes</li>
                                            <li>REPLY</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <!-- At-InfoBox ends  -->

                            <div class="At-InfoBox">
                                <div class="At-InfoImg">
                                    <figure class="At-FigureW55">
                                        <img src="assets/images/profile/profile-small4.png" class="img-fluid " alt="">
                                    </figure>
                                </div>
                                <div class="At-InfoTitle d-flex">
                                    <div class="At-TitleLeft">
                                        <h5>Nathaniel.DS: <span class="At-TextDarkGrey2">Bring me a hoodie from there
                                                will ya</span></h5>
                                        <ul class="At-LikesUl">
                                            <li>2m ago</li>
                                            <li>22 Likes</li>
                                            <li>REPLY</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <!-- At-InfoBox ends  -->

                            <div class="At-InfoBox">
                                <div class="At-InfoImg">
                                    <figure class="At-FigureW55">
                                        <img src="assets/images/profile/profile-small3.png" class="img-fluid " alt="">
                                    </figure>
                                </div>
                                <div class="At-InfoTitle d-flex">
                                    <div class="At-TitleLeft">
                                        <h5>Softpetal:): <span class="At-TextDarkGrey2">Enjooyy Sweetiee</span> <i
                                                class="icon-like At-TextRed"></i> </h5>
                                        <ul class="At-LikesUl">
                                            <li>2m ago</li>
                                            <li>22 Likes</li>
                                            <li>REPLY</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <!-- At-InfoBox ends  -->

                            <div class="At-InfoBox">
                                <div class="At-InfoImg">
                                    <figure class="At-FigureW55">
                                        <img src="assets/images/profile/profile-small3.png" class="img-fluid " alt="">
                                    </figure>
                                </div>
                                <div class="At-InfoTitle d-flex">
                                    <div class="At-TitleLeft">
                                        <h5>Softpetal:): <span class="At-TextDarkGrey2">Enjooyy Sweetiee</span> <i
                                                class="icon-like At-TextRed"></i> </h5>
                                        <ul class="At-LikesUl">
                                            <li>2m ago</li>
                                            <li>22 Likes</li>
                                            <li>REPLY</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <!-- At-InfoBox ends  -->

                            <div class="At-InfoBox">
                                <div class="At-InfoImg">
                                    <figure class="At-FigureW55">
                                        <img src="assets/images/profile/profile-small3.png" class="img-fluid " alt="">
                                    </figure>
                                </div>
                                <div class="At-InfoTitle d-flex">
                                    <div class="At-TitleLeft">
                                        <h5>Softpetal:): <span class="At-TextDarkGrey2">Enjooyy Sweetiee</span>
                                        </h5>
                                        <ul class="At-LikesUl">
                                            <li>2m ago</li>
                                            <li>22 Likes</li>
                                            <li>REPLY</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <!-- At-InfoBox ends  -->
                        </div>
                    </div>
                </div>
                <!-- At-SidebarShareMiddle ends  -->
                <div class="At-SidebarShareBottom">
                    <div class="At-SidebarShareBottomInner">
                        <div class="form-group mb-0 At-FormWithIcon">
                            <i class="icon-send-1 At-CursorPointer"></i>
                            <i class="icon-face-emoji iconTwo"></i>
                            <input class="form-control At-InputSearch" type="text" placeholder="Say something ...">
                        </div>
                    </div>
                </div>
                <!-- At-SidebarShareBottomInner ends  -->
            </div>
        </div>
    </div>
</div>
